import {createApi} from '@reduxjs/toolkit/query/react'
import {baseQueryWithReAuth} from "@/store/features/baseRtkQuery";
import {TagsResponse, TagRolesResponse, CreateTagRequest} from "@/services/models/tagsResponse";


export const tagsApiSlice = createApi({
    reducerPath: 'tagsApi',
    baseQuery: baseQueryWithReAuth,
    tagTypes: ['Tags', 'TagRoles'],
    endpoints: (builder) => ({
        getTags: builder.query<TagsResponse, void>({
            query: () => ({
                url: `Tags`,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            }),
            providesTags: ['Tags'],
        }),
        getTagsRoles: builder.query<TagRolesResponse[], void>({
            query: () => ({
                url: `Tags/roles`,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            }),
            providesTags: ['TagRoles'],
        }),
        postNewTag: builder.mutation<void, CreateTagRequest>({
            query: (body) => ({
                url: `Tags`,
                method: 'POST',
                body,
                headers: {
                    'Content-Type': 'application/json'
                },
            }),
            invalidatesTags: ['Tags', 'TagRoles'],
        }),
    }),
})

const {
    useGetTagsQuery,
    useGetTagsRolesQuery,
    usePostNewTagMutation,
} = tagsApiSlice
export const tagsApiActions = {
    useGetTagsQuery,
    useGetTagsRolesQuery,
    usePostNewTagMutation,
}